<script>

import TrainingSeriesForm from "@/components/trainingSeries/form/TrainingSeriesForm.vue";

export default {
    components: {TrainingSeriesForm},
    data() {
        return {
            training: null
        }
    },
    mounted() {
        axios.get('/trainings/' + this.$route.params.id).then((response) => {
            this.training = response.data.data;
        }).catch(() => {
        }).finally(() => {
            this.loadingData = false;
        })
    }
}
</script>

<template>
    <div class="trainings-edit">
        <TrainingSeriesForm v-if="training" :training="training"/>
    </div>
</template>
